import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styles from './WizardStepper.module.css';
function resolveStepState(index, activeStep) {
    if (index < activeStep)
        return 'completed';
    if (index === activeStep)
        return 'active';
    return 'inactive';
}
const dividerClass = {
    completed: styles.dividerCompleted,
    active: styles.dividerActive,
    inactive: styles.dividerInactive,
};
const badgeClass = {
    completed: styles.badgeCompleted,
    active: styles.badgeActive,
    inactive: styles.badgeInactive,
};
const badgeNumberClass = {
    completed: styles.badgeNumberOnFill,
    active: styles.badgeNumberOnFill,
    inactive: styles.badgeNumberInactive,
};
const labelClass = {
    completed: styles.labelCompleted,
    active: styles.labelActive,
    inactive: styles.labelInactive,
};
export function WizardStepper({ steps, activeStep = 0 }) {
    return (_jsx("section", { className: styles.stepper, "data-testid": 'wizard-stepper', children: steps.map((step, index) => {
            const state = resolveStepState(index, activeStep);
            return (_jsxs("div", { className: styles.step, "data-testid": `wizard-stepper-step-${index}`, children: [_jsx("span", { className: `${styles.divider} ${dividerClass[state]}`, "data-testid": `wizard-stepper-divider-${index}` }), _jsxs("div", { className: styles.titleRow, children: [_jsx("span", { className: `${styles.badge} ${badgeClass[state]}`, "data-testid": `wizard-stepper-badge-${index}`, children: _jsx("span", { className: `${styles.badgeNumber} ${badgeNumberClass[state]}`, children: index + 1 }) }), _jsx("span", { className: `${styles.label} ${labelClass[state]}`, children: step.title })] })] }, step.title + index));
        }) }));
}
